document.addEventListener("DOMContentLoaded", () => {
    const tooltips = document.querySelectorAll(".card-video-tooltip");
  
    tooltips.forEach((tooltip) => {
      const videoBlock = tooltip.querySelector('.card-video-block'); // Find the card-video-block inside the tooltip's div
  
      // Toggle the visibility of the div when the tooltip is clicked
      tooltip.addEventListener("click", (event) => {
        event.stopPropagation(); // Prevent the click from propagating to the document
        // Toggle the display of card-video-block
        if (videoBlock.style.display === 'block') {
          videoBlock.style.display = 'none'; // Hide if currently visible
        } else {
          videoBlock.style.display = 'block'; // Show if currently hidden
        }
      });
  
      // Hide the card-video-block when the tooltip loses focus
      tooltip.addEventListener("focusout", () => {
        videoBlock.style.display = 'none'; // Hide the video block when focus is lost
      });
  
      // Optionally, you can also focus the tooltip element when clicking inside it to ensure focus events work.
      tooltip.tabIndex = 0; // Make sure tooltip is focusable
    });
  });
  